/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationConfiguration } from '../../models/integration-configuration';

export interface PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Params {
  posProviderType: string;
  id: string;
}

export function posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet(http: HttpClient, rootUrl: string, params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
  const rb = new RequestBuilder(rootUrl, posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet.PATH, 'get');
  if (params) {
    rb.path('posProviderType', params.posProviderType, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationConfiguration>;
    })
  );
}

posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet.PATH = '/pos-integration-configurations/providers/{posProviderType}/id/{id}';
